/**
 * CAND-DISP-1 — Candidate Review types.
 *
 * Narrow by design: pending candidates only, one disposition per confirm.
 * Not a candidate-management model.
 */

export interface CandidateOrganizationSummary {
  display_name: string | null;
  authoritative_namespace: string | null;
  authoritative_id_raw: string | null;
  review_state: string;
}

export interface CandidateSourceRef {
  source_event_id: string;
}

export interface PendingCandidate {
  candidate_organization_id: string;
  queue_state: string;
  queued_at: string;
  candidate_organizations:
    | CandidateOrganizationSummary
    | CandidateOrganizationSummary[]
    | null;
  candidate_organization_sources:
    | CandidateSourceRef
    | CandidateSourceRef[]
    | null;
}

export interface OrganizationOption {
  organization_id: string;
  legal_name: string;
}

export type Disposition = 'link' | 'promote' | 'reject';

export interface DispositionResult {
  status: 'claimed' | 'already_resolved' | 'resumed';
  disposition?: Disposition;
  redrive?: boolean;
  candidate_organization_id: string;
  canonical_organization_id?: string;
  source_event_id?: string;
  sweep_run_id?: string;
  ingest?: Record<string, number>;
}

/** Flattens the embedded-row shape PostgREST returns for a to-one join. */
export function firstOf<T>(value: T | T[] | null | undefined): T | null {
  if (!value) return null;
  return Array.isArray(value) ? (value[0] ?? null) : value;
}
